export default __webpack_public_path__ + "static/media/service-Business-functions-Accounting.4facce5d.jpg";